import { useEffect, useState } from 'react';

const navLinks = [
  { label: '今晚抢先看', href: '#tonight' },
  { label: '追更日历', href: '#calendar' },
  { label: '剧集分类', href: '#genres' },
  { label: '热播榜单', href: '#rank' },
  { label: '剧情速递', href: '#news' },
  { label: '追更指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#faf6ef]/92 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#e85d3f] text-lg font-bold text-white">
            55
          </span>
          <span className="font-serif-sc text-xl font-black tracking-tight text-[#26201a]">
            吃瓜<span className="text-[#e85d3f]">·追更站</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-full px-3 py-2 text-sm font-medium text-[#6f655a] transition-colors hover:bg-white/70 hover:text-[#e85d3f]"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-full bg-[#26201a] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#e85d3f]"
          >
            订阅更新提醒
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-full text-xl text-[#26201a] lg:hidden"
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-[#26201a]/10 bg-[#faf6ef] px-4 py-3 lg:hidden">
          <ul className="space-y-1">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-[#6f655a] hover:bg-white hover:text-[#e85d3f]"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-full bg-[#26201a] px-5 py-2.5 text-center text-sm font-semibold text-white"
          >
            订阅更新提醒
          </a>
        </div>
      )}
    </header>
  );
}